var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"answer-item"},[_c('div',{staticClass:"content-body",on:{"click":_vm.onClick}},[_c('div',{staticClass:"text-wrapper"},[(_vm.message)?[_c('div',{staticClass:"content-text",domProps:{"innerHTML":_vm._s(_vm.message)}})]:[_c('div',{staticClass:"content-text"},[_vm._t("default")],2)]],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }